export default "__VITE_ASSET__25kWHt1a__"